var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 981 981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#97675e;}.cls-2{fill:#20456e;}.cls-3{fill:#173856;}.cls-4{fill:#639;}.cls-5{fill:#28110b;}.cls-6{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "frame 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "perso_2",
    "data-name": "perso 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 490.41,
    cy: 219.5,
    r: 169
  }), /*#__PURE__*/React.createElement("g", {
    id: "frame_1_3",
    "data-name": "frame 1&3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M941.41,1252.5v-203s0-50,66-50,66,40,66,40v213Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M940.91,1252s12,114,11.29,208.57c-12.86,5.54-9.57,81.43-9.57,81.43l170.57,1.65s10.39-64.36-51.08-70.55c9.36-54.12,12.79-150.1,11.79-221.1C1027.91,1253,940.91,1252,940.91,1252Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 423.91,
    y: 633,
    width: 133,
    height: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "bras_arri\\xE8re",
    "data-name": "bras arri\\xE8re"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M976.24,1250.43s-13.27,74,30,66.51,26.27-72.91,26.27-72.91Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M964.14,1060.78s31.09-79.29,86.08-22.68l-4,212.58s-43.07,18.85-78,3.72C964.9,1179.18,964.14,1060.78,964.14,1060.78Z",
    transform: "translate(-517 -611)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M973.8,1004.55c8.6-3.4,19.44-5.55,33.11-5.55,66,0,68,40,68,40S1059.91,1014,973.8,1004.55Z",
    transform: "translate(-517 -611)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M967.91,915l-10,77.13C941.34,1006.48,777.2,964,814.11,775c2.6-13.31,14-39,29-65-46,0-86,218-160,260-60.69-74-70.11-364.45,110-343,21,3,60,34,63.78,67.17,41.89-39.67,105.21-50.55,161-46.17,26.27,2.06,70.79,18.2,101,41a196,196,0,0,1,49,55c17.2,34-21.82,88.28-111.8,61-13.92,34.16-29.91,57-49.2,62,0,0-27.67-26.15-54-14C926.91,865,932.91,919,967.91,915Z",
    transform: "translate(-517 -611)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cadre_invisible",
    "data-name": "cadre invisible"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 981,
    height: 981
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightFrame1);
export default __webpack_public_path__ + "static/media/right_frame_1.6a294b366019158ba14bda7ab890c24c.svg";
export { ForwardRef as ReactComponent };